import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useHistory } from 'react-router-dom';
import { editBudget } from 'services/api/requests/budget';

export const useEditBudget = (body, id: number) => {
	const queryClient = useQueryClient();
	const history = useHistory();
	const toast = useToast();

	return useMutation(() => editBudget(body, id), {
		onSuccess: () => {
			queryClient.invalidateQueries(['orcamento-list']);
			history.goBack();
			toast({
				title: 'Atualizado com sucesso!',
				description: 'Orçamento atualizado com sucesso.',
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});
		},
		onError: (error: any) => {
			toast({
				title: 'Erro ao atualizar orçamento!',
				description: error.response.data[0].message,
				position: 'bottom-left',
				status: 'error',
				duration: 8000,
				isClosable: true,
			});
		},
	});
};
